// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopArticleTaxHistoryByIdRequestModel from '../../model/get-shop-article-tax-history-by-id-request-model';
import GetShopArticleTaxHistoryByIdRequestDTO from '../dto/get-shop-article-tax-history-by-id-request-dto';
import dtoSchema from '../schemas/get-shop-article-tax-history-by-id-request-schema';

export default abstract class GetShopArticleTaxHistoryByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopArticleTaxHistoryByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetShopArticleTaxHistoryByIdRequestDTO>): GetShopArticleTaxHistoryByIdRequestModel;
  static toModel(dto: DeepPartial<GetShopArticleTaxHistoryByIdRequestDTO> | undefined | null): GetShopArticleTaxHistoryByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopArticleTaxHistoryByIdRequestDTO> | undefined | null): GetShopArticleTaxHistoryByIdRequestModel | undefined {
    return dto ? new GetShopArticleTaxHistoryByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopArticleTaxHistoryByIdRequestModel> | GetShopArticleTaxHistoryByIdRequestModel): GetShopArticleTaxHistoryByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetShopArticleTaxHistoryByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopArticleTaxHistoryByIdRequestModel, can not map to GetShopArticleTaxHistoryByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
